var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-bar'),_c('v-container',[_c('v-row',{staticClass:"mt-5",class:{
				'mt-7': !_vm.$vuetify.breakpoint.mdAndDown,
			},attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","lg":"12","xl":"11"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }